import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import classNames from "classnames";
import { Row, Col } from "react-bootstrap";
import { useAuthContext } from "../contexts/AuthContext";

import SideNavBar from "../components/Navbar/SideNavbar";
import MainNavbar from "../components/Navbar/MainNavbar";

import {
  AuthRoutes,
  SuperadminRoutes,
  AdminRoutes,
  UserRoutes,
} from "../AppRoutes";

import "./MasterLayout.scss";

import ScaleLoader from "react-spinners/ScaleLoader";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
  position: "fixed",
  height: "100%",
  width: "100%",
  opacity: "0.8",
  backgroundColor: "#000",
  zIndex: "9999",
  marginLeft: "-15px",
  paddingTop: "20%",
  paddingLeft: "50%",
};

const NavBar = () => {
  const { isLoggedIn, menuState, menuList, isLoading, user } = useAuthContext();

  const lg_size = isLoggedIn && menuState ? 10 : 12;
  const lg_offset = isLoggedIn && menuState ? 2 : 0;
  const md_size = isLoggedIn && menuState ? 9 : 12;
  const md_offset = isLoggedIn && menuState ? 3 : 0;

  const classes = classNames(
    "main-sidebar",
    "px-0",
    "col-12",
    "col-lg-2",
    "col-md-3",
    menuState && "open"
  );

  const classesMain = classNames(
    "main-content",
    "col-sm-12",
    `col-md-${md_size}`,
    `offset-md-${md_offset}`,
    `col-lg-${lg_size}`,
    `offset-lg-${lg_offset}`,
    menuState && "open"
  );

  return (
    <>
      <ScaleLoader
        cssOverride={override}
        size={40}
        color={"#1484cd"}
        loading={isLoading}
        speedMultiplier={1.5}
      />
      <Row>
        {isLoggedIn && (
          <SideNavBar
            classes={classes}
            sidebarNavItems={menuList}
            userInfo={user}
          />
        )}

        <Col className={classesMain}>
          {isLoggedIn && <MainNavbar />}

          {isLoggedIn === undefined ? (
            <ScaleLoader
              cssOverride={override}
              size={40}
              color={"#1484cd"}
              loading={true}
              speedMultiplier={1.5}
            />
          ) : (
            <Routes>
              {isLoggedIn
                ? user?.role === "superadmin"
                  ? SuperadminRoutes.map((route, index) => {
                      return (
                        <Route
                          key={"route-" + index}
                          path={route.path}
                          element={<route.component />}
                        />
                      );
                    })
                  : user?.role === "admin"
                  ? AdminRoutes.map((route, index) => {
                      return (
                        <Route
                          key={"route-" + index}
                          path={route.path}
                          element={<route.component />}
                        />
                      );
                    })
                  : UserRoutes.map((route, index) => {
                      return (
                        <Route
                          key={"route-" + index}
                          path={route.path}
                          element={<route.component />}
                        />
                      );
                    })
                : AuthRoutes.map((route, index) => {
                    return (
                      <Route
                        key={"route-" + index}
                        path={route.path}
                        element={<route.component />}
                      />
                    );
                  })}
            </Routes>
          )}
        </Col>
      </Row>
    </>
  );
};

export default NavBar;
